<template>
  <div>
    <div class=" position-relative">
      <div class="row no-gutters justify-content-center">
        <div class="fixed-top d-block nav-bottom">
          <div class="custom-container-fluid  px-0">
            <div class="row justify-content-center no-gutters">
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                <div class="bg-green">
                  <div class="w-100">
                    <div class="row ">
                      <router-link :to="'/'+this.getMerchant().code">
                        <div class="col-1">
                          <div class="nav-back" style="top: 15px!important;left: 15px!important;">
                            <img src="../../assets/img/icon/back-white.png" width="20">
                          </div>
                        </div>
                      </router-link>
                      <div class="col-10 py-14px">
                        <p class="text-white heading-6 mb-0">{{getMerchant().name}} {{$t('general.ticket')}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container mt-8 pt-3">
      <div class="row slim-grid-row">
        <div class="col-1">
          <img src="../../assets/img/icon/calendar-green.png" class="mt-2 ml-1" width="20">
        </div>
        <div class="col-11">
          <v-date-picker
            ref='calendar'
            v-model='filter_date'
            :min-date='tx_date_min'
            :popover="{ visibility: 'click' }"
            color='green'
            >
            <div class="row slim-grid-row">
              <div class="col-7">
                <div class="ml-2">
                  <p class="mb-0 text-green sub-heading-1-1">{{displayToday(getTicketCart().visit_date)}}</p>
                  <p class="mb-0 body-3-3 color-black">{{dateIsToday(getTicketCart().visit_date)}}</p>
                </div>
              </div>
              <div class="col-5">
                <p class="mb-0 text-green body-2-1 py-2 px-1 rounded-10 text-center" style="background-color: #EFEFEF">
                {{$t('merchant.change-date')}}</p>
              </div>
            </div>
          </v-date-picker>
        </div>
      </div>
    </div>
    <div class="break bg-green mt-2"></div>
    <loader v-if="ticket.is_load" />
    <div v-else class="container p-3">
      <template v-for="item in ticket.list">
        <ticket :data="item"></ticket>
      </template>
    </div>
    <floating-cart></floating-cart>
  </div>
</template>
<script>
  import {mapGetters, mapActions,mapMutations} from "vuex";
  import {customFormatDateTime} from '@/utils/index.js';
  import {get} from '@/services/index.js';
  import moment from 'moment';
  import Ticket from '@/components/ticket/Ticket';
  import FloatingCart from '@/components/general/FloatingCart'

  export default {
    components:{
      Ticket,
      FloatingCart
    },
    data() {
      return {
        ticket:{
          list: [],
          is_load: false
        },
        filter_date: new Date(),
        temp_filter_date: new Date(),
        // tx_date: moment(this.getTicketCart().visit_date).toDate(),
        tx_date_min: new Date(),
        warning_merchant_notfound_show: false
      }
    },
    mounted(){
      document.getElementById('ticket').scrollIntoView({
          behavior: 'smooth'
      });
      this.loadTicketList(this.getMerchant().id)
      // let today = new Date()
      // let today_converted = moment(today).format("YYYY-MM-DD");
      // let vuex_date_converted = moment(this.getTicketCart().visit_date).format("YYYY-MM-DD");
      // if(moment(vuex_date_converted).isSame(today_converted) == false && moment(this.getTicketCart().visit_date).isBefore(today)){
      //   this.ticketSetBookingDateCart(today);
      //   this.tx_date = moment(this.getTicketCart().visit_date).toDate()
      // }else{
      // }
    },
    created(){
      this.checkAndFillDate()
    },
    computed:{
      visit_date(){
        return this.getTicketCart().visit_date
      }
    },
    watch:{
      filter_date(){
        if(this.filter_date != null){
          if(this.getMerchant().id) {
            this.ticketSetBookingDateCart(this.filter_date);
            this.loadTicketList(this.getMerchant().id)
            this.ticketResetItemCart()
          }
          this.temp_filter_date = this.filter_date
        }else{
          this.filter_date = moment(this.temp_filter_date).toDate()
        }
      }
    },
    methods:{
      // vuex func
      ...mapGetters(['getTicketCart','getMerchant']),
      ...mapActions(['ticketSetBookingDateCart','ticketResetItemCart','ticketListAddAct']),
      ...mapMutations(['setTicketAvb']),
      // manipulation data
      formatDate(date){
        return customFormatDateTime(date,null,'ddd, DD MMM YYYY')
      },
      displayToday(date){
        // check if date is today
        if (moment().isSame(moment(date),'day')) return this.$t('merchant.today')

        // else
        return customFormatDateTime(date,null,'dddd')
      },
      dateIsToday(date){
        // check if date is today
        if (moment().isSame(moment(date),'day')) return this.formatDate(date) 

        // else
        return customFormatDateTime(date,null,'DD MMM YYYY')
      },
      loadTicketList(merchant_id){
        this.ticket.is_load = true
        let visit_date = moment(this.getTicketCart().visit_date).format("YYYY-MM-DD")
        get("CORE","ticket",{
          merchant_id: merchant_id,
          date_time: visit_date
        }).then(response=>{
          let res = response.data
          if (res.success) {
            for(let i=0;i>res.data.length;i++){
              for(let j=0;j>res.data[i].variants.length;j++){
                res.data.variants[j].qty = 0
              }
            }
            this.ticket.list = res.data
            this.ticketListAddAct(res.data)
            this.saveAvbl(this.ticket.list)
          }
          this.ticket.is_load = false
        })
      },
      saveAvbl(data){
        let ticket_avb = []
        data.forEach(product=>{
          product.variants.forEach(variant=>{
            let new_data = {
              id: variant.id,
              availability: variant.availability,
              original_availability: variant.availability
            }
            if(!variant.use_master_availability){
              let is_exist = ticket_avb.findIndex(x=>x.id == variant.id)
              if(is_exist == -1){
                // ADD NEW
                ticket_avb.push(new_data)
              }else{
                // UPDATE AVAILABILITY
                ticket_avb[is_exist].availability = variant.availability
                ticket_avb[is_exist].original_availability = variant.availability
              }
            }else{
              let is_exist = ticket_avb.findIndex(x=>x.id == variant.master_availability_reference_id)
              if(is_exist == -1){
                // ADD NEW THE PARENT
                new_data.id = variant.master_availability_reference_id
                ticket_avb.push(new_data)
              }
            }
          })
        })
        this.setTicketAvb(ticket_avb)
      },
      changeVisitDate(e){
        this.ticketSetBookingDateCart(e.date);
      },
      checkAndFillDate(){
        let today = moment()
        let fltr_date = moment(this.getTicketCart().visit_date)
        if(moment(fltr_date).isBefore(today)){
          this.ticketSetBookingDateCart(today);
        }
        let copied_data = JSON.parse(JSON.stringify(this.getTicketCart()))
        this.filter_date = moment(copied_data.visit_date).toDate()
      },

      // action
      goToHome(){
        this.$router.push({
          path: '/'+this.getMerchant().code  
        })
      }
    }
  }

</script>
<style scoped>
  .break {
    background-color: #e9ebf2;
    height: 6px;
    border-top: 1px solid #e2e2e2;
  }

  .color-black {
    color: #000 !important;
  }

  .color-bold-light {
    color: #000000A6;
  }

  .plus-min-set input {
    margin-top: 10px;
  }

@media only screen and (max-width: 321px){
    .counter{
      width: 25px !important;
    }
  }

  @media only screen and (min-width: 600px){
    .counter{
      text-align: right !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/ticket/TicketActivities.vue